module.exports = __webpack_public_path__ + "static/media/check-blc.6dc54c80.svg";